export const APPLICATIONS_RESET_STATE = 'APPLICATIONS_RESET_STATE';
export const APPLICATIONS_CURRENT_ITEM = 'APPLICATIONS_CURRENT_ITEM';

export const APPLICATIONS_REQUEST_LOADING = 'APPLICATIONS_REQUEST_LOADING';
export const APPLICATIONS_REQUEST_SUCCESS = 'APPLICATIONS_REQUEST_SUCCESS';
export const APPLICATIONS_REQUEST_FAILED = 'APPLICATIONS_REQUEST_FAILED';

export const APPLICATIONS_CURRENT_ACTION = 'APPLICATIONS_CURRENT_ACTION';
export const APPLICATIONS_RESET_ACTION = 'APPLICATIONS_RESET_ACTION';